export default __webpack_public_path__ + "static/media/logisticYellowLeft.68bb19a4.svg";